var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSourceSansProRegular(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "SourceSansPro",
    horizAdvX: 522
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Source Sans Pro",
    unitsPerEm: 1000,
    panose1: "2 11 5 3 3 4 3 2 2 4",
    ascent: 984,
    descent: -273,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    glyphName: "space",
    horizAdvX: 200
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    glyphName: "exclam",
    horizAdvX: 289,
    d: "M116 198L105 576L103 670H186L184 576L173 198H116ZM145 -12Q120 -12 103 5T85 50Q85 79 102 96T145 114Q169 114 186 97T204 50Q204 23 187 6T145 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    glyphName: "quotedbl",
    horizAdvX: 425,
    d: "M99 431L83 598L80 690H168L165 598L149 431H99ZM275 431L259 598L256 690H344L341 598L325 431H275Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    glyphName: "numbersign",
    horizAdvX: 497,
    d: "M90 0L115 204H35V261H122L140 409H55V467H147L170 650H223L200 467H333L357 650H410L386 467H467V409H380L362 261H447V204H355L330 0H277L301 204H169L144 0H90ZM176 261H308L326 409H194L176 261Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    glyphName: "dollar",
    horizAdvX: 497,
    d: "M222 -110V-11Q174 -6 129 15T52 66L90 123Q122 95 160 76T245 56Q301 56 328 84T356 159Q356 199 336 225T284 271T217 308T149 347T98 400T77 481Q77 548 116 592T222 647V748H282V649Q330 644 363 623T424 573L380 524Q352 551 326 566T258 581Q212 581 185 555T158 485Q158 449 178 426T230 386T297 352T365 312T416 254T437 165Q437 93 396 47T282 -9V-110H222Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    glyphName: "percent",
    horizAdvX: 824,
    d: "M184 254Q116 254 76 308T35 462Q35 561 75 614T184 668Q251 668 292 615T333 462Q333 362 292 308T184 254ZM184 305Q222 305 246 344T270 462Q270 540 246 578T184 617Q145 617 121 579T97 462Q97 384 121 345T184 305ZM202 -12L564 668H620L258 -12H202ZM641 -12Q573 -12 533 42T492 196Q492 295 532 348T641 402Q708 402 749 349T790 196Q790 96 749 42T641 -12ZM641 39Q679 39 703 78T727 196Q727 274 703 312T641 351Q602 351 578 313T554 196Q554 118 578 79T641 39Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    glyphName: "ampersand",
    horizAdvX: 609,
    d: "M232 -12Q187 -12 151 1T88 39T47 96T32 170Q32 203 42 230T71 280T112 322T161 359Q141 400 130 438T118 513Q118 546 129 574T160 623T208 656T270 668Q331 668 365 632T399 538Q399 506 386 479T352 429T305 385T251 344Q283 293 326 246T417 160Q447 201 470 249T509 354H586Q566 289 538 230T471 119Q505 96 536 80T594 56L572 -12Q537 -2 499 16T421 63Q383 29 337 9T232 -12ZM189 514Q189 487 197 458T220 399Q242 414 262 429T298 461T323 496T332 537Q332 566 318 587T270 609Q233 609 211 582T189 514ZM241 54Q275 54 306 68T366 107Q318 149 274 198T194 302Q159 274 136 244T112 175Q112 148 122 126T149 87T190 63T241 54Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    glyphName: "quotesingle",
    horizAdvX: 249,
    d: "M99 431L83 598L80 690H168L165 598L149 431H99Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    glyphName: "parenleft",
    horizAdvX: 303,
    d: "M214 -176Q152 -76 117 35T82 278Q82 410 117 520T214 732L265 708Q207 612 179 503T150 278Q150 163 178 54T265 -152L214 -176Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    glyphName: "parenright",
    horizAdvX: 303,
    d: "M89 -176L38 -152Q96 -56 124 53T153 278Q153 393 125 502T38 708L89 732Q151 631 186 521T221 278Q221 146 186 35T89 -176Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    glyphName: "asterisk",
    horizAdvX: 418,
    d: "M138 420L98 449L155 543L58 583L73 629L175 604L184 712H233L242 605L345 629L360 583L263 543L319 449L280 420L209 506L138 420Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    glyphName: "plus",
    horizAdvX: 497,
    d: "M216 104V299H34V361H216V556H281V361H463V299H281V104H216Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    glyphName: "comma",
    horizAdvX: 249,
    d: "M67 -170L47 -122Q90 -103 114 -72T137 0Q134 -1 127 -1Q103 -1 86 13T68 56Q68 83 86 98T129 114Q161 114 179 88T198 17Q198 -48 163 -96T67 -170Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    glyphName: "hyphen",
    horizAdvX: 311,
    d: "M41 219V282H271V219H41Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    glyphName: "period",
    horizAdvX: 249,
    d: "M125 -12Q100 -12 83 5T65 50Q65 79 82 96T125 114Q149 114 166 97T184 50Q184 23 167 6T125 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    glyphName: "slash",
    horizAdvX: 350,
    d: "M10 -160L277 710H337L70 -160H10Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    glyphName: "zero",
    horizAdvX: 497,
    d: "M249 -12Q152 -12 98 74T44 321Q44 482 98 566T249 650Q345 650 399 566T453 321Q453 160 399 74T249 -12ZM249 54Q277 54 299 69T338 117T364 200T373 321Q373 391 364 441T339 522T300 569T249 584Q221 584 198 569T159 523T133 441T124 321Q124 181 158 118T249 54Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    glyphName: "one",
    horizAdvX: 497,
    d: "M79 0V68H225V538H109V591Q153 599 185 610T244 638H307V68H439V0H79Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    glyphName: "two",
    horizAdvX: 497,
    d: "M40 0V49Q112 121 168 179T262 286T320 377T340 458Q340 513 310 548T219 583Q179 583 145 561T83 506L36 553Q76 597 121 623T229 650Q318 650 369 599T420 462Q420 417 401 372T347 278T265 177T160 65Q186 67 214 69T267 71H452V0H40Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    glyphName: "three",
    horizAdvX: 497,
    d: "M236 -12Q198 -12 167 -5T109 15T63 44T26 78L68 132Q97 102 135 79T231 56Q289 56 326 87T363 173Q363 201 353 224T318 265T255 291T159 300V363Q210 363 244 372T300 397T331 435T340 482Q340 529 311 556T230 583Q190 583 157 565T94 518L50 570Q87 605 131 627T233 650Q275 650 310 639T370 608T410 557T424 488Q424 430 392 393T308 336V332Q337 325 362 312T406 278T435 230T446 170Q446 128 430 94T385 37T318 1T236 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    glyphName: "four",
    horizAdvX: 497,
    d: "M304 0V176H17V230L290 638H382V242H469V176H382V0H304ZM104 242H304V427Q304 453 305 488T309 550H305Q293 527 280 505T253 460L104 242Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    glyphName: "five",
    horizAdvX: 497,
    d: "M234 -12Q196 -12 165 -5T108 15T62 42T25 75L65 129Q93 100 131 78T226 56Q255 56 280 66T325 96T355 142T366 202Q366 268 329 305T230 342Q197 342 174 332T121 303L77 331L98 638H417V567H170L153 378Q176 390 199 397T251 404Q292 404 328 392T391 356T433 294T449 204Q449 152 431 112T383 45T315 3T234 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    glyphName: "six",
    horizAdvX: 497,
    d: "M268 -12Q221 -12 181 7T112 64T65 160T48 295Q48 391 68 458T122 568T199 630T291 650Q343 650 380 631T445 582L399 531Q379 554 352 567T294 581Q261 581 231 567T178 521T141 438T126 310Q156 347 196 368T275 390Q358 390 407 341T457 193Q457 147 442 110T401 45T341 3T268 -12ZM268 53Q292 53 312 63T347 91T370 135T379 193Q379 256 350 292T261 328Q230 328 194 309T128 244Q136 150 171 102T268 53Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    glyphName: "seven",
    horizAdvX: 497,
    d: "M177 0Q181 90 193 165T226 307T281 438T362 567H44V638H455V587Q398 515 363 449T306 315T276 170T262 0H177Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    glyphName: "eight",
    horizAdvX: 497,
    d: "M250 -12Q205 -12 167 1T101 37T57 93T41 163Q41 194 51 220T78 268T116 306T161 335V339Q126 364 99 399T72 486Q72 523 86 553T124 604T181 638T253 650Q295 650 328 638T384 603T420 549T433 480Q433 455 425 432T404 389T376 353T345 326V322Q366 310 386 295T421 260T446 215T456 158Q456 122 441 91T399 37T334 1T250 -12ZM295 348Q327 377 344 409T362 476Q362 524 333 556T251 589Q206 589 177 561T148 486Q148 457 160 437T192 400T239 372T295 348ZM252 49Q308 49 342 80T377 161Q377 192 363 214T325 252T270 282T204 310Q166 284 141 250T115 171Q115 144 125 122T154 84T198 58T252 49Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    glyphName: "nine",
    horizAdvX: 497,
    d: "M235 310Q267 310 302 330T369 395Q361 489 325 537T228 585Q205 585 185 575T149 547T126 502T117 445Q117 382 146 346T235 310ZM205 -12Q154 -12 116 7T51 55L97 107Q117 84 144 70T202 56Q236 56 266 70T319 116T356 201T371 330Q341 292 301 270T221 248Q138 248 89 297T40 445Q40 491 55 528T95 593T155 635T228 650Q275 650 315 631T385 574T431 478T448 343Q448 247 428 180T374 70T297 8T205 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    glyphName: "colon",
    horizAdvX: 249,
    d: "M125 349Q100 349 83 366T65 411Q65 440 82 457T125 475Q149 475 166 458T184 411Q184 384 167 367T125 349ZM125 -12Q100 -12 83 5T65 50Q65 79 82 96T125 114Q149 114 166 97T184 50Q184 23 167 6T125 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    glyphName: "semicolon",
    horizAdvX: 249,
    d: "M125 349Q100 349 83 366T65 411Q65 440 82 457T125 475Q149 475 166 458T184 411Q184 384 167 367T125 349ZM67 -170L47 -122Q90 -103 114 -72T137 0Q134 -1 127 -1Q103 -1 86 13T68 56Q68 83 86 98T129 114Q161 114 179 88T198 17Q198 -48 163 -96T67 -170Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    glyphName: "less",
    horizAdvX: 497,
    d: "M463 131L34 299V365L463 533V462L252 384L118 334V330L252 280L463 202V131Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    glyphName: "equal",
    horizAdvX: 497,
    d: "M34 406V468H463V406H34ZM34 449V511H463V449H34Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    glyphName: "greater",
    horizAdvX: 497,
    d: "M34 131V202L245 280L379 330V334L245 384L34 462V533L463 365V299L34 131Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    glyphName: "question",
    horizAdvX: 425,
    d: "M160 198Q154 237 162 268T186 326T220 376T257 421T285 467T297 517Q297 557 273 585T200 614Q167 614 138 599T85 556L38 599Q70 635 112 658T210 682Q286 682 331 640T377 522Q377 489 365 462T336 411T299 364T263 315T237 262T232 198H160ZM198 -12Q173 -12 156 5T139 50Q139 79 156 96T198 114Q223 114 240 97T258 50Q258 23 241 6T198 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    glyphName: "at",
    horizAdvX: 847,
    d: "M403 -155Q329 -155 265 -132T154 -64T79 49T51 203Q51 303 84 385T175 525T308 614T468 646Q544 646 604 622T707 555T773 450T796 315Q796 249 778 200T730 117T666 66T596 49Q555 49 527 68T493 125H491Q466 96 434 77T369 57Q318 57 284 93T249 198Q249 238 262 279T301 354T361 409T441 430Q467 430 487 419T521 382H523L534 422H589L550 222Q520 105 604 105Q628 105 651 119T694 159T726 224T738 312Q738 372 721 423T668 512T581 570T461 591Q394 591 331 564T219 486T141 365T111 206Q111 133 133 76T196 -20T290 -79T409 -100Q455 -100 496 -88T571 -55L593 -104Q508 -155 403 -155ZM385 113Q406 113 428 127T477 172L506 331Q492 354 477 363T442 373Q412 373 389 357T349 316T324 261T315 203Q315 155 335 134T385 113Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    glyphName: "A",
    horizAdvX: 544,
    d: "M203 367L172 267H369L338 367Q320 422 304 476T272 588H268Q253 531 237 477T203 367ZM3 0L225 656H319L541 0H452L390 200H151L88 0H3Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    glyphName: "B",
    horizAdvX: 588,
    d: "M90 0V656H285Q335 656 376 647T447 619T493 570T510 496Q510 447 486 408T414 353V349Q474 338 511 299T548 192Q548 144 530 108T479 48T400 12T299 0H90ZM173 377H270Q354 377 391 406T428 485Q428 542 390 566T274 590H173V377ZM173 66H287Q372 66 419 97T466 195Q466 256 420 284T287 313H173V66Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    glyphName: "C",
    horizAdvX: 571,
    d: "M338 -12Q276 -12 224 11T134 77T74 184T52 328Q52 407 74 470T135 577T227 644T343 668Q403 668 448 644T523 587L478 533Q452 561 419 578T344 595Q297 595 259 577T194 524T153 440T138 330Q138 268 152 219T193 134T256 80T341 61Q389 61 425 80T493 135L539 83Q500 38 451 13T338 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    glyphName: "D",
    horizAdvX: 615,
    d: "M90 0V656H254Q406 656 485 572T564 331Q564 253 544 192T485 88T389 23T258 0H90ZM173 68H248Q363 68 420 137T478 331Q478 456 421 522T248 588H173V68Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    glyphName: "E",
    horizAdvX: 527,
    d: "M90 0V656H468V586H173V380H422V309H173V71H478V0H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    glyphName: "F",
    horizAdvX: 494,
    d: "M90 0V656H468V586H173V364H423V294H173V0H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    glyphName: "G",
    horizAdvX: 617,
    d: "M348 -12Q283 -12 229 11T135 77T74 184T52 328Q52 407 74 470T137 577T232 644T353 668Q387 668 415 661T467 643T509 617T542 587L496 533Q471 559 438 577T355 595Q305 595 265 577T197 524T154 440T138 330Q138 268 152 219T194 134T262 80T356 61Q391 61 422 71T474 100V271H335V340H550V64Q518 31 466 10T348 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    glyphName: "H",
    horizAdvX: 652,
    d: "M90 0V656H173V381H478V656H562V0H478V309H173V0H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    glyphName: "I",
    horizAdvX: 263,
    d: "M90 0V656H173V0H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    glyphName: "J",
    horizAdvX: 480,
    d: "M212 -12Q89 -12 31 93L91 135Q113 96 141 79T204 61Q257 61 283 93T309 201V656H393V193Q393 151 383 114T351 48T295 4T212 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    glyphName: "K",
    horizAdvX: 579,
    d: "M90 0V656H173V327H176L449 656H543L338 406L575 0H482L286 341L173 208V0H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    glyphName: "L",
    horizAdvX: 486,
    d: "M90 0V656H173V71H460V0H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    glyphName: "M",
    horizAdvX: 727,
    d: "M90 0V656H190L316 306Q328 272 339 238T363 169H367Q379 203 389 237T412 306L536 656H637V0H559V361Q559 405 563 458T570 555H566L514 406L390 66H335L211 406L159 555H155Q158 511 161 458T165 361V0H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    glyphName: "N",
    horizAdvX: 647,
    d: "M90 0V656H176L413 244L484 108H488Q485 158 482 211T478 317V656H557V0H471L233 413L162 548H158Q162 498 165 447T169 343V0H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    glyphName: "O",
    horizAdvX: 664,
    d: "M332 -12Q270 -12 219 12T130 80T73 188T52 331Q52 410 72 472T130 578T218 645T332 668Q394 668 445 645T534 578T592 472T613 331Q613 252 593 189T535 81T446 12T332 -12ZM332 61Q376 61 411 80T472 134T512 219T526 331Q526 392 512 441T473 524T412 576T332 595Q288 595 253 577T192 524T152 441T138 331Q138 269 152 220T191 135T252 80T332 61Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    glyphName: "P",
    horizAdvX: 566,
    d: "M90 0V656H277Q332 656 377 646T455 614T505 554T523 463Q523 411 506 373T456 310T380 273T281 260H173V0H90ZM173 328H271Q357 328 398 360T440 463Q440 534 397 561T267 589H173V328Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    glyphName: "Q",
    horizAdvX: 664,
    d: "M332 57Q376 57 411 76T472 131T512 217T526 331Q526 392 512 441T473 524T412 576T332 595Q288 595 253 577T192 524T152 441T138 331Q138 268 152 218T191 131T252 76T332 57ZM533 -165Q488 -165 450 -154T381 -121T328 -72T291 -9Q237 -2 193 25T118 96T69 199T52 331Q52 410 72 472T130 578T218 645T332 668Q394 668 445 645T534 578T592 472T613 331Q613 260 597 202T550 100T476 29T381 -8Q404 -52 446 -73T542 -95Q564 -95 580 -93T611 -86L627 -150Q612 -156 587 -160T533 -165Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    glyphName: "R",
    horizAdvX: 569,
    d: "M90 0V656H295Q345 656 387 647T460 615T508 558T525 472Q525 395 485 349T377 286L544 0H450L292 277H173V0H90ZM173 345H283Q360 345 401 376T442 472Q442 537 401 563T283 589H173V345Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    glyphName: "S",
    horizAdvX: 534,
    d: "M272 -12Q203 -12 144 14T42 85L92 143Q127 106 174 84T273 61Q338 61 374 90T410 168Q410 193 402 210T379 240T344 263T301 284L207 325Q184 335 160 349T117 383T86 430T74 494Q74 531 89 563T132 618T197 655T280 668Q339 668 389 646T474 587L429 533Q399 562 363 578T280 595Q225 595 192 570T158 499Q158 475 167 459T193 430T228 408T267 390L360 350Q388 338 413 323T456 287T484 239T495 175Q495 136 480 102T435 43T365 3T272 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    glyphName: "T",
    horizAdvX: 536,
    d: "M226 0V586H28V656H508V586H310V0H226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    glyphName: "U",
    horizAdvX: 645,
    d: "M323 -12Q273 -12 230 2T155 50T105 138T87 271V656H170V269Q170 210 182 170T214 106T263 72T323 61Q356 61 384 71T433 106T466 170T478 269V656H558V271Q558 192 540 138T491 51T416 3T323 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    glyphName: "V",
    horizAdvX: 515,
    d: "M210 0L0 656H89L194 302Q212 243 225 193T258 85H262Q280 143 294 193T325 302L430 656H515L307 0H210Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    glyphName: "W",
    horizAdvX: 786,
    d: "M162 0L23 656H109L178 299Q187 245 197 193T216 87H220Q231 141 243 193T266 299L357 656H433L524 299Q536 247 548 194T572 87H576Q585 141 594 193T613 299L682 656H762L626 0H526L427 395Q418 433 411 469T395 544H391Q383 506 375 470T358 395L261 0H162Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    glyphName: "X",
    horizAdvX: 513,
    d: "M15 0L206 339L28 656H120L209 488Q222 465 233 444T260 393H264Q278 422 288 443T311 488L398 656H486L307 335L498 0H406L310 177Q297 201 284 226T254 282H250Q236 252 223 227T198 177L103 0H15Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    glyphName: "Y",
    horizAdvX: 476,
    d: "M196 0V254L-1 656H88L173 471Q189 435 204 400T236 328H240Q257 365 274 400T306 471L390 656H477L280 254V0H196Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    glyphName: "Z",
    horizAdvX: 539,
    d: "M45 0V50L390 586H76V656H494V607L148 71H497V0H45Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    glyphName: "bracketleft",
    horizAdvX: 303,
    d: "M94 -152V708H273V661H156V-105H273V-152H94Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    glyphName: "backslash",
    horizAdvX: 350,
    d: "M281 -160L14 710H73L340 -160H281Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    glyphName: "bracketright",
    horizAdvX: 303,
    d: "M31 -152V-105H147V661H31V708H209V-152H31Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    glyphName: "asciicircum",
    horizAdvX: 497,
    d: "M60 284L212 670H285L437 284H365L300 460L251 593H247L197 460L132 284H60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    glyphName: "underscore",
    horizAdvX: 500,
    d: "M12 -126V-71H488V-126H12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    glyphName: "grave",
    horizAdvX: 542,
    d: "M285 573L128 726L186 781L327 614L285 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    glyphName: "a",
    horizAdvX: 504,
    d: "M194 -12Q133 -12 93 24T52 126Q52 206 123 248T350 308Q350 331 346 353T330 392T300 419T250 430Q208 430 171 414T105 378L73 435Q107 457 156 477T264 498Q353 498 393 444T433 298V0H365L358 58H355Q320 29 280 9T194 -12ZM218 54Q253 54 284 70T350 119V254Q289 246 248 235T181 209T144 175T132 132Q132 90 157 72T218 54Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    glyphName: "b",
    horizAdvX: 553,
    d: "M297 -12Q263 -12 227 4T158 50H155L148 0H82V712H164V518L162 430Q195 459 234 478T314 498Q361 498 397 481T457 431T494 353T507 251Q507 189 490 140T444 57T377 6T297 -12ZM283 57Q313 57 338 70T382 108T411 169T422 250Q422 290 415 323T393 379T353 416T294 429Q235 429 164 363V108Q196 80 227 69T283 57Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    glyphName: "c",
    horizAdvX: 456,
    d: "M274 -12Q226 -12 184 5T112 54T64 134T46 242Q46 303 65 350T116 431T190 481T280 498Q328 498 362 481T422 441L380 387Q359 406 336 418T283 430Q250 430 222 417T174 378T143 319T131 242Q131 200 142 166T172 108T220 70T281 56Q315 56 343 70T395 105L431 50Q398 21 358 5T274 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    glyphName: "d",
    horizAdvX: 555,
    d: "M248 -12Q156 -12 102 54T47 242Q47 301 64 348T111 429T178 480T258 498Q300 498 331 483T394 442L390 525V712H473V0H405L398 57H395Q366 29 329 9T248 -12ZM266 57Q300 57 330 73T390 124V378Q359 406 331 417T272 429Q243 429 218 416T173 378T143 319T132 243Q132 155 167 106T266 57Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    glyphName: "e",
    horizAdvX: 496,
    d: "M279 -12Q230 -12 188 5T114 55T64 135T46 242Q46 302 64 349T113 430T183 480T264 498Q310 498 346 482T407 436T445 364T458 270Q458 257 458 245T455 223H127Q132 145 175 100T289 54Q324 54 353 64T410 92L439 38Q407 18 368 3T279 -12ZM126 282H386Q386 356 355 394T266 433Q240 433 217 423T174 394T143 346T126 282Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    glyphName: "f",
    horizAdvX: 292,
    d: "M96 0V419H30V481L96 486V563Q96 638 130 681T238 724Q261 724 281 720T319 708L301 645Q274 657 246 657Q178 657 178 563V486H281V419H178V0H96Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    glyphName: "g",
    horizAdvX: 504,
    d: "M246 -224Q201 -224 164 -216T101 -190T60 -149T45 -93Q45 -62 64 -34T116 17V21Q98 32 86 51T73 100Q73 131 90 154T126 190V194Q102 214 83 247T63 325Q63 365 77 397T117 451T175 486T246 498Q266 498 283 495T315 486H484V423H384Q401 406 412 380T424 323Q424 284 410 253T372 200T316 166T246 154Q228 154 209 158T173 171Q160 160 151 147T142 113Q142 90 160 75T228 60H322Q407 60 449 33T492 -56Q492 -90 475 -120T426 -174T349 -210T246 -224ZM246 209Q267 209 285 217T318 240T341 276T349 325Q349 379 319 408T246 438Q203 438 173 409T143 325Q143 298 151 277T173 240T206 217T246 209ZM258 -167Q293 -167 321 -159T370 -137T401 -105T412 -68Q412 -34 387 -21T314 -8H230Q216 -8 200 -7T167 0Q141 -19 129 -40T117 -82Q117 -121 154 -144T258 -167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    glyphName: "h",
    horizAdvX: 544,
    d: "M82 0V712H164V518L161 418Q196 451 234 474T323 498Q400 498 435 450T471 308V0H389V297Q389 366 367 396T297 427Q259 427 230 408T164 352V0H82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    glyphName: "i",
    horizAdvX: 246,
    d: "M82 0V486H164V0H82ZM124 586Q100 586 84 601T67 639Q67 663 83 677T124 692Q148 692 164 678T181 639Q181 616 165 601T124 586Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    glyphName: "j",
    horizAdvX: 247,
    d: "M32 -217Q9 -217 -9 -213T-40 -204L-23 -142Q-14 -145 -2 -147T23 -150Q59 -150 71 -125T83 -55V486H165V-55Q165 -129 135 -173T32 -217ZM125 586Q101 586 85 601T68 639Q68 663 84 677T125 692Q148 692 164 678T181 639Q181 616 165 601T125 586Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    glyphName: "k",
    horizAdvX: 495,
    d: "M82 0V712H163V230H166L373 486H464L301 291L486 0H396L254 234L163 128V0H82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    glyphName: "l",
    horizAdvX: 255,
    d: "M169 -12Q122 -12 102 16T82 98V712H164V92Q164 72 171 64T187 56Q191 56 194 56T205 58L216 -4Q208 -8 197 -10T169 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    glyphName: "m",
    horizAdvX: 829,
    d: "M82 0V486H150L157 416H160Q192 451 229 474T311 498Q367 498 398 474T445 405Q483 447 521 472T605 498Q680 498 716 450T753 308V0H671V297Q671 366 649 396T581 427Q526 427 459 352V0H377V297Q377 366 355 396T286 427Q231 427 164 352V0H82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    glyphName: "n",
    horizAdvX: 547,
    d: "M82 0V486H150L157 416H160Q195 451 233 474T323 498Q400 498 435 450T471 308V0H389V297Q389 366 367 396T297 427Q259 427 230 408T164 352V0H82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    glyphName: "o",
    horizAdvX: 542,
    d: "M271 -12Q226 -12 186 5T114 54T65 134T46 242Q46 303 64 350T114 431T185 481T271 498Q316 498 356 481T428 431T477 351T496 242Q496 182 478 135T428 55T357 5T271 -12ZM271 56Q302 56 328 69T372 107T401 166T411 242Q411 284 401 318T373 378T328 416T271 430Q240 430 214 417T170 378T141 319T131 242Q131 200 141 166T169 108T214 70T271 56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    glyphName: "p",
    horizAdvX: 555,
    d: "M82 -205V486H150L157 430H160Q193 458 232 478T315 498Q362 498 398 481T458 431T494 353T507 250Q507 188 490 140T444 57T377 6T297 -12Q263 -12 230 3T162 44L164 -41V-205H82ZM283 57Q313 57 338 70T382 108T411 169T422 250Q422 290 415 323T393 379T353 416T294 429Q263 429 232 412T164 363V108Q197 80 228 69T283 57Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    glyphName: "q",
    horizAdvX: 555,
    d: "M390 -205V-32L394 56Q365 27 328 8T248 -12Q156 -12 102 54T47 242Q47 301 64 348T111 429T178 480T258 498Q300 498 332 484T397 440H399L407 486H473V-205H390ZM266 57Q300 57 330 73T390 124V378Q359 406 331 417T272 429Q243 429 218 416T173 378T143 319T132 243Q132 155 167 106T266 57Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    glyphName: "r",
    horizAdvX: 347,
    d: "M82 0V486H150L157 398H160Q185 444 220 471T298 498Q327 498 350 488L334 416Q322 420 312 422T287 424Q256 424 223 399T164 312V0H82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    glyphName: "s",
    horizAdvX: 419,
    d: "M209 -12Q157 -12 110 7T28 55L69 110Q101 84 134 68T212 52Q260 52 284 74T308 128Q308 147 298 161T273 185T237 204T197 220Q171 229 145 240T99 268T65 307T52 360Q52 389 63 414T96 458T149 487T219 498Q265 498 303 482T370 443L331 391Q306 410 279 422T220 434Q174 434 153 413T131 364Q131 347 140 335T164 313T198 296T239 280Q265 270 291 259T339 232T373 191T387 133Q387 103 376 77T342 31T286 0T209 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    glyphName: "t",
    horizAdvX: 338,
    d: "M235 -12Q196 -12 170 0T127 33T103 84T96 150V419H24V481L100 486L110 622H179V486H310V419H179V149Q179 104 195 80T254 55Q267 55 282 59T309 68L325 6Q305 -1 282 -6T235 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    glyphName: "u",
    horizAdvX: 544,
    d: "M224 -12Q146 -12 111 36T75 178V486H158V189Q158 120 179 90T249 59Q287 59 316 78T380 141V486H462V0H394L387 76H384Q350 36 313 12T224 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    glyphName: "v",
    horizAdvX: 467,
    d: "M187 0L12 486H97L189 210Q200 174 211 138T234 67H238Q249 102 260 138T282 210L374 486H455L283 0H187Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    glyphName: "w",
    horizAdvX: 718,
    d: "M159 0L24 486H108L180 205Q188 170 195 137T209 70H213Q221 104 229 137T246 205L321 486H401L477 205Q486 170 494 137T511 70H515Q523 104 530 137T545 205L616 486H694L564 0H464L394 261Q385 296 378 330T361 401H357Q349 364 341 330T323 260L255 0H159Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    glyphName: "x",
    horizAdvX: 446,
    d: "M14 0L173 254L26 486H115L180 379Q191 359 203 339T228 298H232Q243 318 254 338T276 379L335 486H421L274 245L432 0H343L272 113Q259 135 246 157T219 200H215Q202 179 190 158T166 113L100 0H14Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    glyphName: "y",
    horizAdvX: 467,
    d: "M90 -209Q73 -209 59 -207T33 -199L49 -134Q57 -136 67 -138T86 -141Q128 -141 154 -112T196 -37L207 -1L12 486H97L196 217Q207 185 219 150T243 80H247Q258 113 268 149T288 217L375 486H455L272 -40Q259 -76 243 -107T205 -160T155 -196T90 -209Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    glyphName: "z",
    horizAdvX: 425,
    d: "M31 0V44L287 419H59V486H391V442L135 67H399V0H31Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    glyphName: "braceleft",
    horizAdvX: 303,
    d: "M228 -152Q169 -152 140 -124T111 -19Q111 8 112 32T115 80T118 126T120 174Q120 189 116 202T103 227T76 245T34 252V304Q59 304 76 311T102 328T116 353T120 381Q120 432 116 476T111 575Q111 652 140 680T228 708H273V661H246Q205 661 192 640T178 570Q178 524 181 482T184 389Q184 340 170 315T124 280V276Q156 267 170 241T184 167Q184 116 181 74T178 -14Q178 -63 191 -84T246 -105H273V-152H228Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    glyphName: "bar",
    horizAdvX: 241,
    d: "M92 -250V750H150V-250H92Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    glyphName: "braceright",
    horizAdvX: 303,
    d: "M31 -152V-105H57Q98 -105 111 -84T125 -14Q125 32 123 74T120 167Q120 215 133 241T179 276V280Q147 289 134 314T120 389Q120 440 122 482T125 570Q125 619 112 640T57 661H31V708H75Q105 708 127 702T163 680T185 640T192 575Q192 520 188 476T183 381Q183 352 201 329T269 304V252Q244 252 228 245T201 227T187 203T183 174Q183 149 184 126T187 80T190 33T192 -19Q192 -58 185 -83T164 -124T127 -145T75 -152H31Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    glyphName: "asciitilde",
    horizAdvX: 497,
    d: "M336 257Q306 257 283 270T239 299T199 328T159 341Q137 341 118 327T82 280L36 313Q63 361 96 382T161 403Q191 403 214 390T258 361T298 332T338 319Q360 319 379 333T415 380L461 346Q434 298 401 278T336 257Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    glyphName: "uni00A0",
    horizAdvX: 202
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    glyphName: "exclamdown",
    horizAdvX: 289,
    d: "M103 -184L105 -90L116 288H173L184 -90L186 -184H103ZM145 372Q120 372 103 389T85 436Q85 463 102 480T145 498Q169 498 186 481T204 436Q204 407 187 390T145 372Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    glyphName: "cent",
    horizAdvX: 497,
    d: "M143 310Q143 243 174 199T262 142V477Q207 464 175 420T143 310ZM262 -33V71Q217 76 180 94T117 143T76 215T61 310Q61 362 76 403T119 474T183 522T262 547V653H314V550Q358 548 390 531T445 492L405 440Q385 458 363 469T314 482V138Q346 140 372 153T418 185L454 133Q425 107 389 90T314 70V-33H262Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    glyphName: "sterling",
    horizAdvX: 497,
    d: "M54 0V50Q105 78 132 125T160 230Q160 244 158 257T153 285H53V337L120 341H138Q128 373 120 403T111 466Q111 508 124 542T162 600T221 637T297 650Q351 650 388 629T452 575L404 528Q385 551 361 566T303 581Q249 581 221 549T192 464Q192 432 199 403T216 341H375V285H229Q231 271 232 258T234 229Q234 176 218 141T172 75V71H453V0H54Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    glyphName: "currency",
    horizAdvX: 497,
    d: "M70 103L26 148L90 213Q73 236 64 265T54 329Q54 364 63 393T90 446L26 512L70 557L138 487Q186 524 249 524Q278 524 307 515T359 487L427 557L471 512L406 446Q423 423 433 394T443 329Q443 294 433 265T406 213L471 148L427 103L359 172Q336 153 307 144T249 134Q185 134 138 172L70 103ZM249 195Q273 195 294 204T332 232T357 274T367 329Q367 359 358 383T332 426T295 453T249 463Q225 463 203 454T165 426T140 384T130 329Q130 299 139 275T165 232T203 205T249 195Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    glyphName: "yen",
    horizAdvX: 497,
    d: "M207 0V158H45V206H207V271H45V318H186L23 638H109L187 467Q202 434 216 401T247 332H251Q268 367 282 400T312 467L390 638H474L310 318H452V271H289V206H452V158H289V0H207Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    glyphName: "brokenbar",
    horizAdvX: 241,
    d: "M92 291V750H150V291H92ZM92 -250V214H150V-250H92Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    glyphName: "section",
    horizAdvX: 497,
    d: "M117 348Q117 315 137 294T187 256T253 226T320 193Q349 207 364 226T380 278Q380 312 360 334T310 372T245 403T178 435Q149 419 133 399T117 348ZM236 -64Q182 -64 138 -45T63 7L113 52Q138 28 167 14T236 0Q276 0 298 20T321 69Q321 97 301 116T250 150T183 179T117 215T66 266T45 343Q45 387 69 419T131 472Q116 488 108 508T99 554Q99 580 108 603T137 645T185 673T251 684Q299 684 337 667T405 627L365 574Q341 594 314 607T254 620Q212 620 194 602T175 557Q175 530 195 512T247 479T313 449T380 413T431 361T452 284Q452 236 429 207T367 155Q381 138 389 119T397 73Q397 43 385 18T352 -25T301 -53T236 -64Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    glyphName: "dieresis",
    horizAdvX: 542,
    d: "M175 587Q153 587 139 601T125 637Q125 658 139 672T175 687Q196 687 210 673T224 637Q224 616 210 602T175 587ZM367 587Q346 587 332 601T318 637Q318 658 332 672T367 687Q389 687 403 673T417 637Q417 616 403 602T367 587Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    glyphName: "copyright",
    horizAdvX: 744,
    d: "M372 -11Q307 -11 248 12T145 79T75 184T49 323Q49 399 75 460T145 564T248 630T372 653Q437 653 495 630T598 564T669 460T695 323Q695 246 669 185T599 80T496 13T372 -11ZM372 31Q429 31 479 52T566 111T626 203T648 323Q648 388 626 441T567 533T479 591T372 612Q315 612 265 592T178 533T118 442T96 323Q96 257 118 204T177 112T265 52T372 31ZM380 125Q342 125 309 138T251 177T212 239T198 323Q198 366 213 401T254 461T313 499T383 512Q425 512 454 496T508 455L473 416Q453 436 433 446T386 457Q331 457 298 420T264 323Q264 257 296 219T383 180Q415 180 439 192T485 224L515 182Q487 158 456 142T380 125Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    glyphName: "ordfeminine",
    horizAdvX: 345,
    d: "M136 387Q91 387 64 412T37 481Q37 534 84 561T236 600Q235 632 222 652T174 673Q148 673 121 663T73 639L50 682Q75 697 109 710T183 724Q243 724 270 689T298 591V395H248L241 432H237Q217 414 192 401T136 387ZM154 436Q193 436 236 476V561Q159 553 129 534T98 486Q98 460 113 448T154 436Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    glyphName: "guillemotleft",
    horizAdvX: 429,
    d: "M181 66L45 221V283L181 438L217 408L99 252L217 94L181 66ZM339 66L203 221V283L339 438L375 408L257 252L375 94L339 66Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    glyphName: "logicalnot",
    horizAdvX: 497,
    d: "M397 104V299H34V361H463V104H397Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    glyphName: "uni00AD",
    horizAdvX: 311,
    d: "M41 219V282H271V219H41Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    glyphName: "registered",
    horizAdvX: 423,
    d: "M211 319Q172 319 138 333T79 374T38 436T23 516Q23 560 38 596T78 658T138 698T211 713Q250 713 284 699T344 658T385 596T400 516Q400 472 385 436T345 374T285 334T211 319ZM211 356Q242 356 269 367T317 400T348 450T360 516Q360 551 349 580T317 631T270 665T211 677Q179 677 152 665T106 632T75 581T63 516Q63 480 74 451T105 400T152 368T211 356ZM139 417V620H215Q247 620 270 606T293 555Q293 537 283 522T256 500L302 417H256L221 487H180V417H139ZM180 519H206Q249 519 249 553Q249 568 240 577T208 586H180V519Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    glyphName: "overscore",
    horizAdvX: 542,
    d: "M138 601V658H404V601H138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    glyphName: "degree",
    horizAdvX: 331,
    d: "M166 429Q141 429 119 438T79 463T51 503T41 556Q41 586 51 609T78 650T118 676T166 685Q191 685 213 676T253 650T281 610T291 556Q291 527 281 504T254 464T214 438T166 429ZM166 475Q199 475 220 498T241 556Q241 593 220 616T166 639Q133 639 112 616T91 556Q91 521 112 498T166 475Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    glyphName: "plusminus",
    horizAdvX: 497,
    d: "M216 127V304H34V366H216V556H281V366H463V304H281V127H216ZM34 0V62H463V0H34Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    glyphName: "two.sups",
    horizAdvX: 367,
    d: "M52 395V432Q97 473 132 505T190 565T225 615T237 661Q237 699 217 721T162 743Q137 743 116 727T78 686L40 721Q63 755 96 776T170 797Q229 797 264 765T300 671Q300 643 289 617T259 565T213 510T155 450H320V395H52Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    glyphName: "three.sups",
    horizAdvX: 367,
    d: "M180 383Q132 383 95 404T35 459L78 492Q96 465 121 450T177 434Q209 434 232 452T255 504Q255 538 223 555T134 573V614Q185 614 212 634T240 684Q240 712 221 729T169 746Q147 746 127 733T90 699L51 733Q77 762 107 779T179 797Q204 797 226 790T266 770T293 737T303 692Q303 657 284 634T235 596Q268 588 293 564T319 500Q319 473 308 452T278 415T234 391T180 383Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    glyphName: "acute",
    horizAdvX: 542,
    d: "M257 573L215 614L356 781L414 726L257 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    glyphName: "uni00B5",
    horizAdvX: 562,
    d: "M82 -179V486H164V189Q164 124 184 92T253 59Q269 59 285 62T317 76T349 105T382 154V486H465Q463 387 461 285T459 95Q459 75 469 66T495 56Q507 56 524 62L535 0Q524 -5 511 -8T477 -12Q435 -12 415 10T389 82H387Q361 35 327 13T252 -10Q223 -10 199 -1T158 37Q158 1 158 -26T160 -78T162 -126T165 -179H82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    glyphName: "paragraph",
    horizAdvX: 560,
    d: "M380 -80V656H464V-80H380ZM293 226Q239 226 193 238T113 277T60 345T41 443Q41 502 59 542T109 608T186 645T282 656H326V226H293Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    glyphName: "middot",
    horizAdvX: 249,
    d: "M125 259Q100 259 83 276T65 321Q65 350 82 367T125 385Q149 385 166 368T184 321Q184 294 167 277T125 259Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    glyphName: "cedilla",
    horizAdvX: 542,
    d: "M190 -226L182 -186Q245 -181 268 -170T291 -136Q291 -116 274 -105T214 -88L258 3H311L282 -64Q317 -72 336 -88T355 -135Q355 -179 313 -200T190 -226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    glyphName: "one.sups",
    horizAdvX: 367,
    d: "M172 395V703H87V745Q120 751 142 760T184 785H236V395H172Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    glyphName: "ordmasculine",
    horizAdvX: 365,
    d: "M182 387Q151 387 124 398T75 431T42 484T30 555Q30 595 42 626T75 680T123 713T182 724Q213 724 240 713T289 680T322 627T334 555Q334 515 322 484T289 432T241 399T182 387ZM182 438Q224 438 247 470T270 555Q270 609 247 641T182 673Q140 673 117 641T93 555Q93 503 116 471T182 438Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    glyphName: "guillemotright",
    horizAdvX: 429,
    d: "M89 66L54 94L172 252L54 408L89 438L226 283V221L89 66ZM247 66L212 94L330 252L212 408L247 438L384 283V221L247 66Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    glyphName: "onequarter",
    horizAdvX: 781,
    d: "M149 266V574H64V616Q97 622 119 631T161 656H213V266H149ZM180 -12L542 668H598L236 -12H180ZM633 0V104H455V137L619 390H691V150H749V104H691V0H633ZM522 150H633V220L637 329H633L583 248L522 150Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    glyphName: "onehalf",
    horizAdvX: 808,
    d: "M149 266V574H64V616Q97 622 119 631T161 656H213V266H149ZM159 -12L521 668H577L215 -12H159ZM493 0V37Q538 78 573 110T631 170T666 220T678 266Q678 304 658 326T603 348Q578 348 557 332T519 291L481 326Q504 360 537 381T611 402Q670 402 705 370T741 276Q741 248 730 222T700 170T654 115T596 55H761V0H493Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    glyphName: "threequarters",
    horizAdvX: 796,
    d: "M180 254Q132 254 95 275T35 330L78 363Q96 336 121 321T177 305Q209 305 232 323T255 375Q255 409 223 426T134 444V485Q185 485 212 505T240 555Q240 583 221 600T169 617Q147 617 127 604T90 570L51 604Q77 633 107 650T179 668Q204 668 226 661T266 641T293 608T303 563Q303 528 284 505T235 467Q268 459 293 435T319 371Q319 344 308 323T278 286T234 262T180 254ZM217 -12L579 668H635L273 -12H217ZM648 0V104H470V137L634 390H706V150H764V104H706V0H648ZM537 150H648V220L652 329H648L598 248L537 150Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    glyphName: "questiondown",
    horizAdvX: 425,
    d: "M215 -196Q139 -196 94 -154T48 -36Q48 -3 60 24T89 75T126 122T162 171T187 224T192 288H265Q270 249 262 218T239 160T205 110T168 65T140 19T128 -31Q128 -71 152 -99T225 -127Q258 -127 287 -112T339 -70L387 -113Q355 -148 313 -172T215 -196ZM227 372Q202 372 185 389T167 436Q167 463 184 480T227 498Q251 498 268 481T286 436Q286 407 269 390T227 372Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    glyphName: "Agrave",
    horizAdvX: 544,
    d: "M203 367L172 267H369L338 367Q320 422 304 476T272 588H268Q253 531 237 477T203 367ZM3 0L225 656H319L541 0H452L390 200H151L88 0H3ZM288 697L136 812L183 867L325 739L288 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    glyphName: "Aacute",
    horizAdvX: 544,
    d: "M203 367L172 267H369L338 367Q320 422 304 476T272 588H268Q253 531 237 477T203 367ZM3 0L225 656H319L541 0H452L390 200H151L88 0H3ZM254 697L217 739L359 867L406 812L254 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    glyphName: "Acircumflex",
    horizAdvX: 544,
    d: "M203 367L172 267H369L338 367Q320 422 304 476T272 588H268Q253 531 237 477T203 367ZM3 0L225 656H319L541 0H452L390 200H151L88 0H3ZM123 725L228 838H314L419 725L383 699L273 792H269L159 699L123 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    glyphName: "Atilde",
    horizAdvX: 544,
    d: "M203 367L172 267H369L338 367Q320 422 304 476T272 588H268Q253 531 237 477T203 367ZM3 0L225 656H319L541 0H452L390 200H151L88 0H3ZM346 709Q318 709 298 720T262 744T231 769T198 780Q179 780 166 763T150 714L94 718Q97 775 124 808T196 841Q224 841 244 830T280 806T311 781T344 770Q384 770 392 836L448 832Q445 774 418 742T346 709Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    glyphName: "Adieresis",
    horizAdvX: 544,
    d: "M203 367L172 267H369L338 367Q320 422 304 476T272 588H268Q253 531 237 477T203 367ZM3 0L225 656H319L541 0H452L390 200H151L88 0H3ZM168 715Q147 715 133 729T119 764Q119 786 133 799T168 813Q190 813 203 800T217 764Q217 743 204 729T168 715ZM374 715Q352 715 339 729T325 764Q325 786 338 799T374 813Q395 813 409 800T423 764Q423 743 409 729T374 715Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    glyphName: "Aring",
    horizAdvX: 544,
    d: "M203 367L172 267H369L338 367Q320 422 304 476T272 588H268Q253 531 237 477T203 367ZM3 0L225 656H319L541 0H452L390 200H151L88 0H3ZM271 699Q229 699 202 723T174 789Q174 831 201 855T271 880Q313 880 340 856T368 789Q368 748 341 724T271 699ZM271 735Q291 735 306 749T322 789Q322 815 307 829T271 843Q249 843 234 829T219 789Q219 763 234 749T271 735Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    glyphName: "AE",
    horizAdvX: 822,
    d: "M290 376L229 258H401V590H397Q344 483 290 376ZM8 0L352 656H763V586H485V380H717V309H485V71H773V0H401V191H195L96 0H8Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    glyphName: "Ccedilla",
    horizAdvX: 571,
    d: "M338 -12Q276 -12 224 11T134 77T74 184T52 328Q52 407 74 470T135 577T227 644T343 668Q403 668 448 644T523 587L478 533Q452 561 419 578T344 595Q297 595 259 577T194 524T153 440T138 330Q138 268 152 219T193 134T256 80T341 61Q389 61 425 80T493 135L539 83Q500 38 451 13T338 -12ZM256 -226L248 -186Q311 -181 334 -170T357 -136Q357 -116 340 -105T280 -88L324 3H377L348 -64Q383 -72 402 -88T421 -135Q421 -179 379 -200T256 -226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    glyphName: "Egrave",
    horizAdvX: 527,
    d: "M90 0V656H468V586H173V380H422V309H173V71H478V0H90ZM301 697L149 812L196 867L338 739L301 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    glyphName: "Eacute",
    horizAdvX: 527,
    d: "M90 0V656H468V586H173V380H422V309H173V71H478V0H90ZM267 697L230 739L372 867L419 812L267 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    glyphName: "Ecircumflex",
    horizAdvX: 527,
    d: "M90 0V656H468V586H173V380H422V309H173V71H478V0H90ZM136 725L241 838H327L432 725L396 699L286 792H282L172 699L136 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    glyphName: "Edieresis",
    horizAdvX: 527,
    d: "M90 0V656H468V586H173V380H422V309H173V71H478V0H90ZM181 715Q160 715 146 729T132 764Q132 786 146 799T181 813Q203 813 216 800T230 764Q230 743 217 729T181 715ZM387 715Q365 715 352 729T338 764Q338 786 351 799T387 813Q408 813 422 800T436 764Q436 743 422 729T387 715Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    glyphName: "Igrave",
    horizAdvX: 263,
    d: "M90 0V656H173V0H90ZM148 697L-4 812L43 867L185 739L148 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    glyphName: "Iacute",
    horizAdvX: 263,
    d: "M90 0V656H173V0H90ZM114 697L77 739L219 867L266 812L114 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    glyphName: "Icircumflex",
    horizAdvX: 263,
    d: "M90 0V656H173V0H90ZM-17 725L88 838H174L279 725L243 699L133 792H129L19 699L-17 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    glyphName: "Idieresis",
    horizAdvX: 263,
    d: "M90 0V656H173V0H90ZM28 715Q7 715 -7 729T-21 764Q-21 786 -7 799T28 813Q50 813 63 800T77 764Q77 743 64 729T28 715ZM234 715Q212 715 199 729T185 764Q185 786 198 799T234 813Q255 813 269 800T283 764Q283 743 269 729T234 715Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    glyphName: "Eth",
    horizAdvX: 638,
    d: "M33 321V364L112 368V656H276Q428 656 507 572T586 331Q586 253 566 192T507 88T411 23T280 0H112V321H33ZM195 68H270Q385 68 442 137T500 331Q500 456 443 522T270 588H195V368H344V321H195V68Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    glyphName: "Ntilde",
    horizAdvX: 647,
    d: "M90 0V656H176L413 244L484 108H488Q485 158 482 211T478 317V656H557V0H471L233 413L162 548H158Q162 498 165 447T169 343V0H90ZM401 709Q373 709 353 720T317 744T286 769T253 780Q234 780 221 763T205 714L149 718Q152 775 179 808T251 841Q279 841 299 830T335 806T366 781T399 770Q439 770 447 836L503 832Q500 774 473 742T401 709Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    glyphName: "Ograve",
    horizAdvX: 664,
    d: "M332 -12Q270 -12 219 12T130 80T73 188T52 331Q52 410 72 472T130 578T218 645T332 668Q394 668 445 645T534 578T592 472T613 331Q613 252 593 189T535 81T446 12T332 -12ZM332 61Q376 61 411 80T472 134T512 219T526 331Q526 392 512 441T473 524T412 576T332 595Q288 595 253 577T192 524T152 441T138 331Q138 269 152 220T191 135T252 80T332 61ZM349 697L197 812L244 867L386 739L349 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    glyphName: "Oacute",
    horizAdvX: 664,
    d: "M332 -12Q270 -12 219 12T130 80T73 188T52 331Q52 410 72 472T130 578T218 645T332 668Q394 668 445 645T534 578T592 472T613 331Q613 252 593 189T535 81T446 12T332 -12ZM332 61Q376 61 411 80T472 134T512 219T526 331Q526 392 512 441T473 524T412 576T332 595Q288 595 253 577T192 524T152 441T138 331Q138 269 152 220T191 135T252 80T332 61ZM315 697L278 739L420 867L467 812L315 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    glyphName: "Ocircumflex",
    horizAdvX: 664,
    d: "M332 -12Q270 -12 219 12T130 80T73 188T52 331Q52 410 72 472T130 578T218 645T332 668Q394 668 445 645T534 578T592 472T613 331Q613 252 593 189T535 81T446 12T332 -12ZM332 61Q376 61 411 80T472 134T512 219T526 331Q526 392 512 441T473 524T412 576T332 595Q288 595 253 577T192 524T152 441T138 331Q138 269 152 220T191 135T252 80T332 61ZM184 725L289 838H375L480 725L444 699L334 792H330L220 699L184 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    glyphName: "Otilde",
    horizAdvX: 664,
    d: "M332 -12Q270 -12 219 12T130 80T73 188T52 331Q52 410 72 472T130 578T218 645T332 668Q394 668 445 645T534 578T592 472T613 331Q613 252 593 189T535 81T446 12T332 -12ZM332 61Q376 61 411 80T472 134T512 219T526 331Q526 392 512 441T473 524T412 576T332 595Q288 595 253 577T192 524T152 441T138 331Q138 269 152 220T191 135T252 80T332 61ZM407 709Q379 709 359 720T323 744T292 769T259 780Q240 780 227 763T211 714L155 718Q158 775 185 808T257 841Q285 841 305 830T341 806T372 781T405 770Q445 770 453 836L509 832Q506 774 479 742T407 709Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    glyphName: "Odieresis",
    horizAdvX: 664,
    d: "M332 -12Q270 -12 219 12T130 80T73 188T52 331Q52 410 72 472T130 578T218 645T332 668Q394 668 445 645T534 578T592 472T613 331Q613 252 593 189T535 81T446 12T332 -12ZM332 61Q376 61 411 80T472 134T512 219T526 331Q526 392 512 441T473 524T412 576T332 595Q288 595 253 577T192 524T152 441T138 331Q138 269 152 220T191 135T252 80T332 61ZM229 715Q208 715 194 729T180 764Q180 786 194 799T229 813Q251 813 264 800T278 764Q278 743 265 729T229 715ZM435 715Q413 715 400 729T386 764Q386 786 399 799T435 813Q456 813 470 800T484 764Q484 743 470 729T435 715Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    glyphName: "multiply",
    horizAdvX: 497,
    d: "M94 126L50 171L205 330L50 488L94 533L249 374L403 533L447 488L292 330L447 171L403 126L249 286L94 126Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    glyphName: "Oslash",
    horizAdvX: 664,
    d: "M335 -12Q231 -12 160 53L96 -30L50 6L120 97Q89 142 72 200T55 331Q55 410 75 472T133 578T221 645T335 668Q439 668 511 605L573 686L619 651L550 562Q582 518 599 461T616 331Q616 252 596 189T538 81T449 12T335 -12ZM141 331Q141 283 149 242T174 168L462 541Q411 595 335 595Q291 595 256 577T195 524T155 441T141 331ZM335 61Q379 61 414 80T475 134T515 219T529 331Q529 379 521 419T496 491L209 117Q259 61 335 61Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    glyphName: "Ugrave",
    horizAdvX: 645,
    d: "M323 -12Q273 -12 230 2T155 50T105 138T87 271V656H170V269Q170 210 182 170T214 106T263 72T323 61Q356 61 384 71T433 106T466 170T478 269V656H558V271Q558 192 540 138T491 51T416 3T323 -12ZM339 697L187 812L234 867L376 739L339 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    glyphName: "Uacute",
    horizAdvX: 645,
    d: "M323 -12Q273 -12 230 2T155 50T105 138T87 271V656H170V269Q170 210 182 170T214 106T263 72T323 61Q356 61 384 71T433 106T466 170T478 269V656H558V271Q558 192 540 138T491 51T416 3T323 -12ZM305 697L268 739L410 867L457 812L305 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    glyphName: "Ucircumflex",
    horizAdvX: 645,
    d: "M323 -12Q273 -12 230 2T155 50T105 138T87 271V656H170V269Q170 210 182 170T214 106T263 72T323 61Q356 61 384 71T433 106T466 170T478 269V656H558V271Q558 192 540 138T491 51T416 3T323 -12ZM174 725L279 838H365L470 725L434 699L324 792H320L210 699L174 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    glyphName: "Udieresis",
    horizAdvX: 645,
    d: "M323 -12Q273 -12 230 2T155 50T105 138T87 271V656H170V269Q170 210 182 170T214 106T263 72T323 61Q356 61 384 71T433 106T466 170T478 269V656H558V271Q558 192 540 138T491 51T416 3T323 -12ZM219 715Q198 715 184 729T170 764Q170 786 184 799T219 813Q241 813 254 800T268 764Q268 743 255 729T219 715ZM425 715Q403 715 390 729T376 764Q376 786 389 799T425 813Q446 813 460 800T474 764Q474 743 460 729T425 715Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    glyphName: "Yacute",
    horizAdvX: 476,
    d: "M196 0V254L-1 656H88L173 471Q189 435 204 400T236 328H240Q257 365 274 400T306 471L390 656H477L280 254V0H196ZM221 697L184 739L326 867L373 812L221 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    glyphName: "Thorn",
    horizAdvX: 583,
    d: "M90 0V656H173V546H291Q345 546 390 536T466 503T515 444T533 353Q533 301 516 263T466 199T390 162T291 150H173V0H90ZM173 218H281Q367 218 408 250T450 353Q450 424 408 451T281 478H173V218Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    glyphName: "germandbls",
    horizAdvX: 576,
    d: "M387 -12Q345 -12 311 1T246 37L279 95Q305 73 330 63T385 52Q427 52 448 76T469 132Q469 161 455 180T418 213T371 239T323 268T287 306T272 364Q272 398 285 422T315 468T346 513T360 568Q360 606 340 630T277 655Q223 655 194 617T164 500V0H82V515Q82 609 133 665T278 722Q317 722 347 711T399 679T430 633T441 576Q441 538 427 512T396 463T364 421T350 374Q350 350 364 334T401 306T448 280T496 249T532 204T547 137Q547 105 536 78T504 31T454 0T387 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    glyphName: "agrave",
    horizAdvX: 504,
    d: "M194 -12Q133 -12 93 24T52 126Q52 206 123 248T350 308Q350 331 346 353T330 392T300 419T250 430Q208 430 171 414T105 378L73 435Q107 457 156 477T264 498Q353 498 393 444T433 298V0H365L358 58H355Q320 29 280 9T194 -12ZM218 54Q253 54 284 70T350 119V254Q289 246 248 235T181 209T144 175T132 132Q132 90 157 72T218 54ZM276 573L119 726L177 781L318 614L276 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    glyphName: "aacute",
    horizAdvX: 504,
    d: "M194 -12Q133 -12 93 24T52 126Q52 206 123 248T350 308Q350 331 346 353T330 392T300 419T250 430Q208 430 171 414T105 378L73 435Q107 457 156 477T264 498Q353 498 393 444T433 298V0H365L358 58H355Q320 29 280 9T194 -12ZM218 54Q253 54 284 70T350 119V254Q289 246 248 235T181 209T144 175T132 132Q132 90 157 72T218 54ZM248 573L206 614L347 781L405 726L248 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    glyphName: "acircumflex",
    horizAdvX: 504,
    d: "M194 -12Q133 -12 93 24T52 126Q52 206 123 248T350 308Q350 331 346 353T330 392T300 419T250 430Q208 430 171 414T105 378L73 435Q107 457 156 477T264 498Q353 498 393 444T433 298V0H365L358 58H355Q320 29 280 9T194 -12ZM218 54Q253 54 284 70T350 119V254Q289 246 248 235T181 209T144 175T132 132Q132 90 157 72T218 54ZM107 600L221 740H303L417 600L382 568L264 681H260L142 568L107 600Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    glyphName: "atilde",
    horizAdvX: 504,
    d: "M194 -12Q133 -12 93 24T52 126Q52 206 123 248T350 308Q350 331 346 353T330 392T300 419T250 430Q208 430 171 414T105 378L73 435Q107 457 156 477T264 498Q353 498 393 444T433 298V0H365L358 58H355Q320 29 280 9T194 -12ZM218 54Q253 54 284 70T350 119V254Q289 246 248 235T181 209T144 175T132 132Q132 90 157 72T218 54ZM334 577Q307 577 288 590T253 619T223 648T191 661Q168 661 157 639T144 582L89 585Q90 614 96 639T115 682T145 710T190 721Q217 721 236 708T271 679T301 650T334 637Q356 637 367 659T380 716L435 712Q434 683 428 659T409 616T379 588T334 577Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    glyphName: "adieresis",
    horizAdvX: 504,
    d: "M194 -12Q133 -12 93 24T52 126Q52 206 123 248T350 308Q350 331 346 353T330 392T300 419T250 430Q208 430 171 414T105 378L73 435Q107 457 156 477T264 498Q353 498 393 444T433 298V0H365L358 58H355Q320 29 280 9T194 -12ZM218 54Q253 54 284 70T350 119V254Q289 246 248 235T181 209T144 175T132 132Q132 90 157 72T218 54ZM166 587Q144 587 130 601T116 637Q116 658 130 672T166 687Q187 687 201 673T215 637Q215 616 201 602T166 587ZM358 587Q337 587 323 601T309 637Q309 658 323 672T358 687Q380 687 394 673T408 637Q408 616 394 602T358 587Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    glyphName: "aring",
    horizAdvX: 504,
    d: "M194 -12Q133 -12 93 24T52 126Q52 206 123 248T350 308Q350 331 346 353T330 392T300 419T250 430Q208 430 171 414T105 378L73 435Q107 457 156 477T264 498Q353 498 393 444T433 298V0H365L358 58H355Q320 29 280 9T194 -12ZM218 54Q253 54 284 70T350 119V254Q289 246 248 235T181 209T144 175T132 132Q132 90 157 72T218 54ZM262 554Q211 554 182 582T152 653Q152 695 181 723T262 751Q313 751 342 723T372 653Q372 610 343 582T262 554ZM262 591Q286 591 302 607T319 653Q319 681 303 697T262 714Q238 714 222 698T205 653Q205 624 221 608T262 591Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    glyphName: "ae",
    horizAdvX: 785,
    d: "M201 -12Q139 -12 99 24T58 126Q58 206 129 248T352 308Q352 331 348 353T333 392T302 419T253 430Q213 430 177 414T112 378L79 435Q113 457 161 477T263 498Q317 498 352 471T402 395Q431 443 471 470T562 498Q607 498 641 482T699 436T735 364T747 269Q747 241 744 223H429Q430 185 442 154T475 101T522 67T580 55Q615 55 643 66T698 95L728 38Q696 18 658 3T570 -12Q509 -12 468 15T399 79Q349 34 299 11T201 -12ZM224 54Q258 54 298 73T371 129Q363 148 358 174T352 229V254Q294 246 254 235T188 209T151 175T139 132Q139 90 163 72T224 54ZM429 278H675Q675 353 646 393T560 433Q509 433 473 392T429 278Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    glyphName: "ccedilla",
    horizAdvX: 456,
    d: "M274 -12Q226 -12 184 5T112 54T64 134T46 242Q46 303 65 350T116 431T190 481T280 498Q328 498 362 481T422 441L380 387Q359 406 336 418T283 430Q250 430 222 417T174 378T143 319T131 242Q131 200 142 166T172 108T220 70T281 56Q315 56 343 70T395 105L431 50Q398 21 358 5T274 -12ZM185 -226L177 -186Q240 -181 263 -170T286 -136Q286 -116 269 -105T209 -88L253 3H306L277 -64Q312 -72 331 -88T350 -135Q350 -179 308 -200T185 -226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    glyphName: "egrave",
    horizAdvX: 496,
    d: "M279 -12Q230 -12 188 5T114 55T64 135T46 242Q46 302 64 349T113 430T183 480T264 498Q310 498 346 482T407 436T445 364T458 270Q458 257 458 245T455 223H127Q132 145 175 100T289 54Q324 54 353 64T410 92L439 38Q407 18 368 3T279 -12ZM126 282H386Q386 356 355 394T266 433Q240 433 217 423T174 394T143 346T126 282ZM279 573L122 726L180 781L321 614L279 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    glyphName: "eacute",
    horizAdvX: 496,
    d: "M279 -12Q230 -12 188 5T114 55T64 135T46 242Q46 302 64 349T113 430T183 480T264 498Q310 498 346 482T407 436T445 364T458 270Q458 257 458 245T455 223H127Q132 145 175 100T289 54Q324 54 353 64T410 92L439 38Q407 18 368 3T279 -12ZM126 282H386Q386 356 355 394T266 433Q240 433 217 423T174 394T143 346T126 282ZM251 573L209 614L350 781L408 726L251 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    glyphName: "ecircumflex",
    horizAdvX: 496,
    d: "M279 -12Q230 -12 188 5T114 55T64 135T46 242Q46 302 64 349T113 430T183 480T264 498Q310 498 346 482T407 436T445 364T458 270Q458 257 458 245T455 223H127Q132 145 175 100T289 54Q324 54 353 64T410 92L439 38Q407 18 368 3T279 -12ZM126 282H386Q386 356 355 394T266 433Q240 433 217 423T174 394T143 346T126 282ZM110 600L224 740H306L420 600L385 568L267 681H263L145 568L110 600Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    glyphName: "edieresis",
    horizAdvX: 496,
    d: "M279 -12Q230 -12 188 5T114 55T64 135T46 242Q46 302 64 349T113 430T183 480T264 498Q310 498 346 482T407 436T445 364T458 270Q458 257 458 245T455 223H127Q132 145 175 100T289 54Q324 54 353 64T410 92L439 38Q407 18 368 3T279 -12ZM126 282H386Q386 356 355 394T266 433Q240 433 217 423T174 394T143 346T126 282ZM169 587Q147 587 133 601T119 637Q119 658 133 672T169 687Q190 687 204 673T218 637Q218 616 204 602T169 587ZM361 587Q340 587 326 601T312 637Q312 658 326 672T361 687Q383 687 397 673T411 637Q411 616 397 602T361 587Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    glyphName: "igrave",
    horizAdvX: 246,
    d: "M82 0V486H164V0H82ZM137 573L-20 726L38 781L179 614L137 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    glyphName: "iacute",
    horizAdvX: 246,
    d: "M82 0V486H164V0H82ZM109 573L67 614L208 781L266 726L109 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    glyphName: "icircumflex",
    horizAdvX: 246,
    d: "M82 0V486H164V0H82ZM-32 600L82 740H164L278 600L243 568L125 681H121L3 568L-32 600Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    glyphName: "idieresis",
    horizAdvX: 246,
    d: "M82 0V486H164V0H82ZM27 587Q5 587 -9 601T-23 637Q-23 658 -9 672T27 687Q48 687 62 673T76 637Q76 616 62 602T27 587ZM219 587Q198 587 184 601T170 637Q170 658 184 672T219 687Q241 687 255 673T269 637Q269 616 255 602T219 587Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    glyphName: "eth",
    horizAdvX: 545,
    d: "M269 -12Q227 -12 188 4T119 50T71 124T53 222Q53 273 69 314T112 385T177 431T259 447Q297 447 332 431T393 381Q379 443 352 489T286 573L145 500L121 541L248 606Q196 646 136 678L174 730Q210 710 245 688T312 639L454 712L478 671L349 605Q409 544 447 460T485 257Q485 197 470 148T426 63T358 8T269 -12ZM271 56Q305 56 330 70T372 111T397 173T406 254Q406 268 406 282T404 309Q371 353 338 368T271 383Q238 383 212 371T168 337T141 286T131 222Q131 184 142 154T172 102T217 68T271 56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    glyphName: "ntilde",
    horizAdvX: 547,
    d: "M82 0V486H150L157 416H160Q195 451 233 474T323 498Q400 498 435 450T471 308V0H389V297Q389 366 367 396T297 427Q259 427 230 408T164 352V0H82ZM364 577Q337 577 318 590T283 619T253 648T221 661Q198 661 187 639T174 582L119 585Q120 614 126 639T145 682T175 710T220 721Q247 721 266 708T301 679T331 650T364 637Q386 637 397 659T410 716L465 712Q464 683 458 659T439 616T409 588T364 577Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    glyphName: "ograve",
    horizAdvX: 542,
    d: "M271 -12Q226 -12 186 5T114 54T65 134T46 242Q46 303 64 350T114 431T185 481T271 498Q316 498 356 481T428 431T477 351T496 242Q496 182 478 135T428 55T357 5T271 -12ZM271 56Q302 56 328 69T372 107T401 166T411 242Q411 284 401 318T373 378T328 416T271 430Q240 430 214 417T170 378T141 319T131 242Q131 200 141 166T169 108T214 70T271 56ZM285 573L128 726L186 781L327 614L285 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    glyphName: "oacute",
    horizAdvX: 542,
    d: "M271 -12Q226 -12 186 5T114 54T65 134T46 242Q46 303 64 350T114 431T185 481T271 498Q316 498 356 481T428 431T477 351T496 242Q496 182 478 135T428 55T357 5T271 -12ZM271 56Q302 56 328 69T372 107T401 166T411 242Q411 284 401 318T373 378T328 416T271 430Q240 430 214 417T170 378T141 319T131 242Q131 200 141 166T169 108T214 70T271 56ZM257 573L215 614L356 781L414 726L257 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    glyphName: "ocircumflex",
    horizAdvX: 542,
    d: "M271 -12Q226 -12 186 5T114 54T65 134T46 242Q46 303 64 350T114 431T185 481T271 498Q316 498 356 481T428 431T477 351T496 242Q496 182 478 135T428 55T357 5T271 -12ZM271 56Q302 56 328 69T372 107T401 166T411 242Q411 284 401 318T373 378T328 416T271 430Q240 430 214 417T170 378T141 319T131 242Q131 200 141 166T169 108T214 70T271 56ZM116 600L230 740H312L426 600L391 568L273 681H269L151 568L116 600Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    glyphName: "otilde",
    horizAdvX: 542,
    d: "M271 -12Q226 -12 186 5T114 54T65 134T46 242Q46 303 64 350T114 431T185 481T271 498Q316 498 356 481T428 431T477 351T496 242Q496 182 478 135T428 55T357 5T271 -12ZM271 56Q302 56 328 69T372 107T401 166T411 242Q411 284 401 318T373 378T328 416T271 430Q240 430 214 417T170 378T141 319T131 242Q131 200 141 166T169 108T214 70T271 56ZM343 577Q316 577 297 590T262 619T232 648T200 661Q177 661 166 639T153 582L98 585Q99 614 105 639T124 682T154 710T199 721Q226 721 245 708T280 679T310 650T343 637Q365 637 376 659T389 716L444 712Q443 683 437 659T418 616T388 588T343 577Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    glyphName: "odieresis",
    horizAdvX: 542,
    d: "M271 -12Q226 -12 186 5T114 54T65 134T46 242Q46 303 64 350T114 431T185 481T271 498Q316 498 356 481T428 431T477 351T496 242Q496 182 478 135T428 55T357 5T271 -12ZM271 56Q302 56 328 69T372 107T401 166T411 242Q411 284 401 318T373 378T328 416T271 430Q240 430 214 417T170 378T141 319T131 242Q131 200 141 166T169 108T214 70T271 56ZM175 587Q153 587 139 601T125 637Q125 658 139 672T175 687Q196 687 210 673T224 637Q224 616 210 602T175 587ZM367 587Q346 587 332 601T318 637Q318 658 332 672T367 687Q389 687 403 673T417 637Q417 616 403 602T367 587Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    glyphName: "divide",
    horizAdvX: 497,
    d: "M34 299V361H463V299H34ZM249 96Q226 96 210 111T194 150Q194 173 210 188T249 203Q272 203 287 188T303 150Q303 126 288 111T249 96ZM249 456Q226 456 210 471T194 510Q194 533 210 548T249 563Q272 563 287 548T303 510Q303 486 288 471T249 456Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    glyphName: "oslash",
    horizAdvX: 542,
    d: "M271 -12Q192 -12 132 37L83 -23L46 6L100 71Q75 103 61 145T46 242Q46 303 64 350T114 431T185 481T271 498Q309 498 345 486T410 448L460 509L496 480L442 415Q467 383 481 340T496 242Q496 182 478 135T428 55T357 5T271 -12ZM127 246Q127 179 150 133L364 392Q327 432 271 432Q240 432 214 419T168 381T138 322T127 246ZM271 54Q302 54 328 67T374 105T404 164T415 239Q415 306 391 353L178 93Q217 54 271 54Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    glyphName: "ugrave",
    horizAdvX: 544,
    d: "M224 -12Q146 -12 111 36T75 178V486H158V189Q158 120 179 90T249 59Q287 59 316 78T380 141V486H462V0H394L387 76H384Q350 36 313 12T224 -12ZM286 573L129 726L187 781L328 614L286 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    glyphName: "uacute",
    horizAdvX: 544,
    d: "M224 -12Q146 -12 111 36T75 178V486H158V189Q158 120 179 90T249 59Q287 59 316 78T380 141V486H462V0H394L387 76H384Q350 36 313 12T224 -12ZM258 573L216 614L357 781L415 726L258 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    glyphName: "ucircumflex",
    horizAdvX: 544,
    d: "M224 -12Q146 -12 111 36T75 178V486H158V189Q158 120 179 90T249 59Q287 59 316 78T380 141V486H462V0H394L387 76H384Q350 36 313 12T224 -12ZM117 600L231 740H313L427 600L392 568L274 681H270L152 568L117 600Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    glyphName: "udieresis",
    horizAdvX: 544,
    d: "M224 -12Q146 -12 111 36T75 178V486H158V189Q158 120 179 90T249 59Q287 59 316 78T380 141V486H462V0H394L387 76H384Q350 36 313 12T224 -12ZM176 587Q154 587 140 601T126 637Q126 658 140 672T176 687Q197 687 211 673T225 637Q225 616 211 602T176 587ZM368 587Q347 587 333 601T319 637Q319 658 333 672T368 687Q390 687 404 673T418 637Q418 616 404 602T368 587Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    glyphName: "yacute",
    horizAdvX: 467,
    d: "M90 -209Q73 -209 59 -207T33 -199L49 -134Q57 -136 67 -138T86 -141Q128 -141 154 -112T196 -37L207 -1L12 486H97L196 217Q207 185 219 150T243 80H247Q258 113 268 149T288 217L375 486H455L272 -40Q259 -76 243 -107T205 -160T155 -196T90 -209ZM228 573L186 614L327 781L385 726L228 573Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    glyphName: "thorn",
    horizAdvX: 555,
    d: "M82 -205V712H164V518L163 435Q195 461 233 479T311 498Q359 498 395 481T457 431T494 353T507 250Q507 188 490 140T444 57T377 6T297 -12Q262 -12 229 2T163 42L164 -41V-205H82ZM283 57Q313 57 338 70T382 108T411 169T422 250Q422 290 415 323T393 379T353 416T294 429Q263 429 232 412T164 363V108Q197 80 228 69T283 57Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    glyphName: "ydieresis",
    horizAdvX: 467,
    d: "M90 -209Q73 -209 59 -207T33 -199L49 -134Q57 -136 67 -138T86 -141Q128 -141 154 -112T196 -37L207 -1L12 486H97L196 217Q207 185 219 150T243 80H247Q258 113 268 149T288 217L375 486H455L272 -40Q259 -76 243 -107T205 -160T155 -196T90 -209ZM146 587Q124 587 110 601T96 637Q96 658 110 672T146 687Q167 687 181 673T195 637Q195 616 181 602T146 587ZM338 587Q317 587 303 601T289 637Q289 658 303 672T338 687Q360 687 374 673T388 637Q388 616 374 602T338 587Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    glyphName: "endash",
    horizAdvX: 480,
    d: "M41 223V280H439V223H41Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    glyphName: "emdash",
    horizAdvX: 800,
    d: "M41 223V280H759V223H41Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    glyphName: "quoteleft",
    horizAdvX: 249,
    d: "M120 428Q90 428 74 451T57 518Q57 578 84 622T163 696L187 657Q149 632 130 604T111 533Q114 534 120 534Q140 534 156 521T173 483Q173 457 158 443T120 428Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    glyphName: "quoteright",
    horizAdvX: 249,
    d: "M86 431L63 469Q101 494 119 522T138 594Q135 593 130 593Q109 593 93 606T77 643Q77 669 92 684T130 699Q159 699 176 676T193 608Q193 548 166 505T86 431Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    glyphName: "quotesinglbase",
    horizAdvX: 249,
    d: "M86 -144L63 -106Q101 -81 119 -53T138 19Q135 18 130 18Q109 18 93 31T77 68Q77 94 92 109T130 124Q159 124 176 101T193 33Q193 -27 166 -70T86 -144Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    glyphName: "quotedblleft",
    horizAdvX: 425,
    d: "M120 428Q90 428 74 451T57 518Q57 578 84 622T163 696L187 657Q149 632 130 604T111 533Q114 534 120 534Q140 534 156 521T173 483Q173 457 158 443T120 428ZM296 428Q266 428 250 451T233 518Q233 578 260 622T339 696L363 657Q325 632 306 604T287 533Q290 534 296 534Q316 534 332 521T349 483Q349 457 334 443T296 428Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    glyphName: "quotedblright",
    horizAdvX: 425,
    d: "M86 431L63 469Q101 494 119 522T138 594Q135 593 130 593Q109 593 93 606T77 643Q77 669 92 684T130 699Q159 699 176 676T193 608Q193 548 166 505T86 431ZM262 431L239 469Q277 494 295 522T314 594Q311 593 306 593Q285 593 269 606T253 643Q253 669 268 684T306 699Q335 699 352 676T369 608Q369 548 342 505T262 431Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    glyphName: "quotedblbase",
    horizAdvX: 425,
    d: "M86 -144L63 -106Q101 -81 119 -53T138 19Q135 18 130 18Q109 18 93 31T77 68Q77 94 92 109T130 124Q159 124 176 101T193 33Q193 -27 166 -70T86 -144ZM262 -144L239 -106Q277 -81 295 -53T314 19Q311 18 306 18Q285 18 269 31T253 68Q253 94 268 109T306 124Q335 124 352 101T369 33Q369 -27 342 -70T262 -144Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    glyphName: "bullet",
    horizAdvX: 304,
    d: "M152 143Q129 143 109 151T74 176T49 214T40 263Q40 290 49 312T73 350T109 375T152 384Q174 384 194 375T230 351T255 313T264 263Q264 236 255 214T231 176T195 152T152 143Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    glyphName: "guilsinglleft",
    horizAdvX: 271,
    d: "M181 66L45 221V283L181 438L217 408L99 252L217 94L181 66Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    glyphName: "guilsinglright",
    horizAdvX: 271,
    d: "M89 66L54 94L172 252L54 408L89 438L226 283V221L89 66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceSansProRegular);
export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.c6130ac2f5e2e493701d1596637e836c.svg";
export { ForwardRef as ReactComponent };